import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { WebapiService } from '../shared/services/webapi.service';
import { ToastrService } from 'ngx-toastr';
import { Store, select } from '@ngrx/store';
import { AppState } from '../store/app.states';
import { getUserInfo } from '../store/selector/selector';
import { UserInfo } from '../store/actions/user.action';
import { environment } from '../environments/environment';
import { take } from 'rxjs/operators';
import { CustomValidators } from '../shared/validators/CustomValidators';
import {
  injectStripe,
  StripeService,
  StripeCardComponent
} from 'ngx-stripe';

import {
  StripeElementsOptions,
  StripeCardElementOptions
} from '@stripe/stripe-js';

declare var $: any;  

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  @ViewChild(StripeCardComponent) cardElement!: StripeCardComponent;
  cardOptions: StripeCardElementOptions = {
    hidePostalCode: true,
    style: {
      base: {
        iconColor: '#666EE8',
        color: '#31325F',
        fontWeight: '300',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSize: '18px',
        '::placeholder': {
          color: '#CFD7E0'
        }
      }
    }
  };

  elementsOptions: StripeElementsOptions = {
    locale: 'en'
  };

  stripe = injectStripe(environment.STRIPE_PUBLIC_KEY);

  formSubmitting=false;
  formSubmitting2=false;
  loader : boolean = false
  user:any
  countries:any=[];
  maxBirthdayDate = new Date();
  userForm: FormGroup = this.fb.group({
    email: ['', Validators.compose([Validators.required, Validators.email])],
    oldpassword: ['', Validators.compose([Validators.required, Validators.minLength(8)])],
    password: ['', Validators.compose([Validators.minLength(8)])],
    first_name: ['', Validators.compose([Validators.required])],
    last_name: ['', Validators.compose([Validators.required])],
    dob: ['', Validators.compose([Validators.required, CustomValidators.noFutureDateValidator])],
    country: ['', Validators.compose([Validators.required])],
    gym_name: [''],
    number_of_coaches: [''],
    number_of_athletes: [''],
    form_type:['']
  });

  cardForm: FormGroup = this.fb.group({
    name: ['', Validators.compose([Validators.required])]
  });
  card:any;

  constructor(private fb: FormBuilder, public webApi: WebapiService,private store: Store<AppState>, public router: Router, private toastrService: ToastrService) {
    this.maxBirthdayDate.setFullYear( this.maxBirthdayDate.getFullYear() - 18 );
  }

  
  onFileSelected(event) {

    const file:File = event.target.files[0];

    if (file) {

        this.webApi.setLoader(true)
        const reader = new FileReader();

        const formData = new FormData();
        formData.append("thumbnail", file,file.name);

        this.webApi.uploadProfileImage(formData).subscribe((data: any) => {
          if(data.success){
            this.toastrService.success(data.message);
            reader.addEventListener('load', (event: any) => {
              $('.user-img').attr('src',event.target.result)
            })
            
            this.store.dispatch(new UserInfo())
            reader.readAsDataURL(file);
          }else{
            this.toastrService.error(data.message);
          }
          this.webApi.setLoader(false)
        },
        error => {
          this.webApi.setLoader(false)
          this.toastrService.error("unable to handle response");
        });
    }
  }


  ngOnInit()  
  {    
    this.getUserData()
    this.getCountries()
    this.getCards()
  } 

  getCards(){
    this.webApi.getallcards().subscribe((data:any)=>{
      if(data.success==1 && data.cards && data.cards.type=='card'){
        this.card=data.cards.card;
        //console.log('here',this.card)
      }
    },error=>{
      this.toastrService.error("unable to handle response");
    })
  }

  getUserData(){
    this.webApi.setLoader(true)
    this.store.pipe(select(getUserInfo),take(1)).subscribe(data=>{
      this.user = data
      this.initForm()
      this.webApi.setLoader(false)
    },error=>{
      this.webApi.setLoader(false)
      this.toastrService.error("unable to handle response");
    })
    // this.webApi.setLoader(true)
    // this.webApi.getUserData().subscribe((data: any) => {
    //   if(data.success){
    //     this.user=data.data
    //     this.initForm()
    //   }else{
    //     this.toastrService.error(data.message);
    //   }
    //   this.webApi.setLoader(false)
    // },
    // error => {
    //   this.toastrService.error("unable to handle response");
    // });
  }

  initForm(){
    this.userForm = this.fb.group({
      oldpassword: ['', Validators.compose([Validators.required, Validators.minLength(8)])],
      password: ['', Validators.compose([Validators.minLength(8)])],
      first_name: ['', Validators.compose([Validators.required])],
      last_name: ['', Validators.compose([Validators.required])],
      dob: ['', Validators.compose([Validators.required, CustomValidators.noFutureDateValidator])],
      country: ['', Validators.compose([Validators.required])],
      gym_name: ['', (this.user.role=="gymowner" || this.user.role=="choreographer")?Validators.compose([Validators.required]):null],
      // number_of_coaches: ['', this.user.role=="gymowner"?Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")]):null],
      // number_of_athletes: ['', this.user.role=="gymowner"?Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")]):null],
      number_of_coaches: [''],
      number_of_athletes: [''],
      form_type:['']
    });

    this.userForm.patchValue({
      first_name: this.user.first_name,
      last_name: this.user.last_name,
      dob: new Date(this.user.dob),
      country: this.user.country,
      gym_name:this.user.gym_name,
      number_of_coaches: this.user.number_of_coaches,
      number_of_athletes: this.user.number_of_athletes,
      form_type:this.user.role
    });
  }

  getCountries(){
    this.webApi.getCountries().subscribe((data: any) => {
      if (data.success) {
        this.countries=data.countries;
        //this.webApi.setSession(data);
        //this.router.navigateByUrl('/');
        
      } else {
        alert(data.message)
      }
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.userForm.controls;
  }

  get f2(): { [key: string]: AbstractControl } {
    return this.cardForm.controls;
  }


  onUpdate(form: FormGroup) {
    if (form.valid && !this.formSubmitting) {
      this.formSubmitting=true;
      form.value.dob = this.webApi.formatDate(form.value.dob)
      this.webApi.updateProfile(form.value).subscribe((data: any) => {
        if (data.success) {
          this.webApi.setSession(data);
					this.toastrService.success(data.message);
          this.store.dispatch(new UserInfo())
          //this.webApi.setSession(data);
          this.webApi.redirectTo('/profile')
        } else {
					this.toastrService.error(data.message);
        }
        this.formSubmitting=false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.formSubmitting=false;
      });
    } else {
      this.webApi.validateAllFields(form);
    }
  }

  onCardUpdate(form: FormGroup) {
    if (form.valid && !this.formSubmitting2) {
      this.formSubmitting2=true;
      const name = this.cardForm.get('name').value;
      this.stripe
        .createToken(this.cardElement.element, { name })
        .subscribe((result) => {
          if (result.token) {
            // Use the token
            //console.log(result.token.id);
            let params = {
              token:result.token.id
            }
            this.webApi.createpaymentmethod(params).subscribe((data: any) => {
              if (data.success) {
                this.toastrService.success(data.message);
                //this.webApi.setSession(data);
                this.webApi.redirectTo('/profile')
              } else {
                this.toastrService.error(data.message);
              }
              this.formSubmitting2=false;
            },
            error => {
              this.toastrService.error("unable to handle response");
              this.formSubmitting2=false;
            });
          } else if (result.error) {
            this.formSubmitting2=false;
            // Error creating the token
            this.toastrService.error(result.error.message);
          }
        });
      // 
      // form.value.dob = this.webApi.formatDate(form.value.dob)
      
    } else {
      this.webApi.validateAllFields(form);
    }
  }

}


